<div class="container">
    <div class="center" style="text-align: center;">
        <label>
            <h1><b>{{ 'error.information.title' | translate }}</b></h1>
        </label>
        <label>
            {{ 'error.information.description' | translate }}
        </label>
        <br />
        <br />
        <label>
            <button class="btn-reload" (click)="reloadPage()">
                <i class="fal fa-redo"></i>
                {{ 'error.reload.description' | translate }}
            </button>
        </label>
    </div>
</div>